import React, { useState } from 'react';
import { IoCloseSharp } from 'react-icons/io5';
import ImageIcons from '../imageComponent/ImageIcons';
// import ImageIcons from './ImageIcons'; // Make sure this is correctly imported

const IPTVPlans = () => {
  const [activePopup, setActivePopup] = useState(null);

 

  return (
    <section className='pb-0'>
      <div className='container'>
        <div className='max-w-[800px] md:mb-[50px] mb-[40px] text-center mx-auto'>
          <div className='text-[#f48533] uppercase mb-[5px]'>Plans</div>
          <h2>Tariff <span className='text-[#f48533]'>Plans</span> Details</h2>
        </div>
        <div className='grid lg:grid-cols-3 sm:grid-cols-2 xl:gap-[30px] gap-[20px]'>
          {plans.map((plan) => (
            <div
              key={plan.id}
              className="relative xl:p-[25px] p-[20px] border border-[#e5e7eb] item select-plans rounded-[5px]"
            >
              {plan.tag && (
                <span className="absolute -translate-x-2/4 z-30 -top-[12px] left-[50%] mx-auto bg-[#f48533] text-white text-[14px] px-[10px] py-[2px] rounded-[5px]">
                  {plan.tag}
                </span>
              )}
              <h3 className="2xl:text-[24px] text-[20px] font-semibold mb-[15px] text-[#f48533] text-center">
                {plan.speed}
              </h3>

              <div className="text-center bg-[#f7f7f7] my-[10px] py-[5px] rounded-[5px] text-[20px] font-semibold">
                RS.
                <span className="xl:text-[45px] md:text-[36px] sm:text-[32px] text-[28px] font-bold text-[#000]">
                  {plan.price}
                </span>
              </div>

              <ul className="grid gap-[8px] pt-[5px]">
                <li className="text-center">
                  <strong className="whitespace-nowrap font-medium">Duration: </strong>
                  {plan.duration}
                </li>
                <li className="flex justify-center gap-[6px] items-center">
                  <strong className="whitespace-nowrap font-medium">Free OTT: </strong>
                  <ul className='flex items-center'>
                    {plan.showLogos?.slice(0, 4).map((logo, index) => (
                      <li
                        key={index}
                        className={`w-[35px] h-[35px] border border-[#fff] rounded-full overflow-hidden ${index !== 0 ? '-ml-[12px]' : ''}`}
                      >
                        <img className='w-full h-full object-cover' src={logo} alt='OTT logo' />
                      </li>
                    ))}

                    {plan.logos?.length > 4 && (
                      <div className="relative z-30">
                        <li
                          onClick={() => setActivePopup(plan.id)}
                          className='w-[35px] h-[35px] border border-[#7a7a7a] rounded-full overflow-hidden -ml-[12px] flex items-center justify-center bg-white cursor-pointer text-[13px]'
                        >
                          +{plan.logos.length - 4}
                        </li>
                      </div>
                    )}
                  </ul>
                </li>
              </ul>
            </div>
          ))}
        </div>
      </div>

      {activePopup && (
        <div className="fixed inset-0 bg-black bg-opacity-90 flex items-center justify-center z-[9999999999]"
          onClick={() => setActivePopup(null)}>
          <div className="bg-white md:p-[40px] p-[30px] rounded-xl shadow-lg max-w-[700px] mx-[15px] text-center relative"
            onClick={(e) => e.stopPropagation()}>
            <ul className='grid md:grid-cols-7 sm:grid-cols-5 grid-cols-5 flex-wrap sm:gap-[10px] gap-[5px] justify-center items-center overflow-y-auto'>
              {plans.find(p => p.id === activePopup)?.logos.map((logo, index) => (
                <li key={index} className='inline-block lg:max-w-[80px] sm:max-w-[70px] max-w-[50px] bg-[#f7f7f7]'>
                  <img src={logo} alt={`OTT logo ${index + 1}`} className="w-full h-auto" />
                </li>
              ))}
            </ul>
            <button className="absolute top-0 right-0 bg-[#e27629] text-white duration-500 h-[30px] w-[30px] flex justify-center items-center rounded hover:bg-[#f48533]"
              onClick={() => setActivePopup(null)}>
              <IoCloseSharp />
            </button>
          </div>
        </div>
      )}
    </section>
  );
};

export default IPTVPlans;


const plans = [
  {
    id: 'plan1',
    name: 'IPTV FTA',
    speed: '50 Mbps Unlimited',
    data: 'Unlimited Plan',
    price: '399',
    durationMonths: '1 Month',
    duration: '1 Month',
    offer: 'Free OTT',
    tag: 'Value Plan',
    showLogos: [ ImageIcons.shemaroo, ImageIcons.hungama, ImageIcons.dangalPlay, ImageIcons.chanaJor],
     logos: [
      ImageIcons.shemaroo,
      ImageIcons.hungama,
      ImageIcons.iTap,
      ImageIcons.fancode,
      ImageIcons.dangalPlay,
      ImageIcons.distroTv,
      ImageIcons.omTv,
      ImageIcons.hubhopper,
      ImageIcons.aaoNext,
      ImageIcons.shucaeFilms,
      ImageIcons.chanaJor,
      ImageIcons.shortsTv,
      ImageIcons.travelxp,
      ImageIcons.wave
    ]
  },
  {
    id: 'plan4',
    name: 'IPTV SILVER HD',
    speed: '200 Mbps Unlimited',
    data: 'Unlimited Plan',
    price: '699',
    durationMonths: '1 Month',
    duration: '1 Month',
    offer: 'Free OTT',
    tag: 'Best Seller plan',
    showLogos: [ ImageIcons.sonyLiv, ImageIcons.shemaroo, ImageIcons.hungama, ImageIcons.zee5],
    logos: [
      ImageIcons.zee5,
      ImageIcons.sonyLiv,
      ImageIcons.chaupal,
      ImageIcons.discovery,
      ImageIcons.travelxp,
      ImageIcons.dangalPlay,
      ImageIcons.shucaeFilms,
      ImageIcons.nammaflix,
      ImageIcons.tarangplus,
      ImageIcons.shemaroo,
      ImageIcons.hungama,
      ImageIcons.iTap,
      ImageIcons.oneOTT,
      ImageIcons.fancode,
      ImageIcons.distroTv,
      ImageIcons.omTv,
      ImageIcons.hubhopper,
      ImageIcons.aaoNext,
      ImageIcons.kanchanLanka,
      ImageIcons.chanaJor,
      ImageIcons.shortsTv,
      ImageIcons.runtv,
      ImageIcons.eTvWin,
      ImageIcons.wave
    ]
  },
  {
    id: 'plan2',
    name: 'IPTV BRONZE',
    speed: '100 Mbps Unlimited',
    data: 'Unlimited Plan',
    price: '499',
    durationMonths: '1 Month',
    duration: '1 Month',
    offer: 'Free OTT',
    tag: 'Popular Plan',
    showLogos: [ ImageIcons.sonyLiv, ImageIcons.shemaroo, ImageIcons.hungama, ImageIcons.chaupal],
    logos: [
      ImageIcons.sonyLiv,
      ImageIcons.chaupal,
      ImageIcons.shemaroo,
      ImageIcons.hungama,
      ImageIcons.rajTv,
      ImageIcons.iTap,
      ImageIcons.oneOTT,
      ImageIcons.fancode,
      ImageIcons.dangalPlay,
      ImageIcons.distroTv,
      ImageIcons.omTv,
      ImageIcons.hubhopper,
      ImageIcons.aaoNext,
      ImageIcons.shucaeFilms,
      ImageIcons.chanaJor,
      ImageIcons.shortsTv,
      ImageIcons.tarangplus,
      ImageIcons.travelxp,
      ImageIcons.wave
    ]
  },
  {
    id: 'plan5',
    name: 'IPTV GOLD HD',
    speed: '200 Mbps Unlimited',
    data: 'Unlimited Plan',
    price: '799',
    durationMonths: '1 Month',
    duration: '1 Month',
    offer: 'Free OTT',
    tag: 'Premium Plan',
    showLogos: [ ImageIcons.sonyLiv, ImageIcons.shemaroo, ImageIcons.hungama, ImageIcons.zee5],
    logos: [
      ImageIcons.zee5,
      ImageIcons.sonyLiv,
      ImageIcons.chaupal,
      ImageIcons.travelxp,
      ImageIcons.dangalPlay,
      ImageIcons.shucaeFilms,
      ImageIcons.nammaflix,
      ImageIcons.tarangplus,
      ImageIcons.shemaroo,
      ImageIcons.hungama,
      ImageIcons.iTap,
      ImageIcons.oneOTT,
      ImageIcons.fancode,
      ImageIcons.distroTv,
      ImageIcons.omTv,
      ImageIcons.hubhopper,
      ImageIcons.aaoNext,
      ImageIcons.kanchanLanka,
      ImageIcons.chanaJor,
      ImageIcons.shortsTv,
      ImageIcons.runtv,
      ImageIcons.eTvWin,
      ImageIcons.wave
    ]
  },
  {
    id: 'plan6',
    name: 'IPTV GOLD PLUS HD',
    speed: '200 Mbps Unlimited',
    data: 'Unlimited Plan',
    price: '999',
    durationMonths: '1 Month',
    duration: '1 Month',
    offer: 'Free OTT',
    tag: 'Elite Plan',
    showLogos: [ ImageIcons.sonyLiv, ImageIcons.shemaroo, ImageIcons.hungama, ImageIcons.zee5],
    logos: [
      ImageIcons.zee5,
      ImageIcons.sonyLiv,
      ImageIcons.chaupal,
      ImageIcons.travelxp,
      ImageIcons.dangalPlay,
      ImageIcons.shucaeFilms,
      ImageIcons.nammaflix,
      ImageIcons.tarangplus,
      ImageIcons.shemaroo,
      ImageIcons.hungama,
      ImageIcons.iTap,
      ImageIcons.oneOTT,
      ImageIcons.fancode,
      ImageIcons.distroTv,
      ImageIcons.omTv,
      ImageIcons.hubhopper,
      ImageIcons.aaoNext,
      ImageIcons.kanchanLanka,
      ImageIcons.chanaJor,
      ImageIcons.shortsTv,
      ImageIcons.runtv,
      ImageIcons.eTvWin,
      ImageIcons.wave
    ]
  },
  {
    id: 'plan7',
    name: 'IPTV GOLD PLUS HD',
    speed: '300 Mbps Unlimited',
    data: 'Unlimited Plan',
    price: '1299',
    durationMonths: '6+1 Months',
    duration: 'Pay For 6 Months & Get 1 Month Free',
    offer: 'Free OTT',
    tag: 'Fast Plan',
    showLogos: [ ImageIcons.sonyLiv, ImageIcons.shemaroo, ImageIcons.hungama, ImageIcons.zee5],
    logos: [
      ImageIcons.zee5,
      ImageIcons.sonyLiv,
      ImageIcons.chaupal,
      ImageIcons.travelxp,
      ImageIcons.dangalPlay,
      ImageIcons.shucaeFilms,
      ImageIcons.nammaflix,
      ImageIcons.tarangplus,
      ImageIcons.shemaroo,
      ImageIcons.hungama,
      ImageIcons.iTap,
      ImageIcons.oneOTT,
      ImageIcons.fancode,
      ImageIcons.distroTv,
      ImageIcons.omTv,
      ImageIcons.hubhopper,
      ImageIcons.aaoNext,
      ImageIcons.kanchanLanka,
      ImageIcons.chanaJor,
      ImageIcons.shortsTv,
      ImageIcons.runtv,
      ImageIcons.eTvWin,
      ImageIcons.wave
    ]
  },
  {
    id: 'plan3',
    name: 'IPTV SILVER HD',
    speed: '150 Mbps Unlimited',
    data: 'Unlimited Plan',
    price: '599',
    durationMonths: '1 Month',
    duration: '1 Month',
    offer: 'Free OTT',
    tag: 'Standard Plan',
    showLogos: [ ImageIcons.sonyLiv, ImageIcons.shemaroo, ImageIcons.hungama, ImageIcons.zee5],
    logos: [
      ImageIcons.zee5,
      ImageIcons.sonyLiv,
      ImageIcons.chaupal,
      ImageIcons.travelxp,
      ImageIcons.dangalPlay,
      ImageIcons.shucaeFilms,
      ImageIcons.nammaflix,
      ImageIcons.tarangplus,
      ImageIcons.shemaroo,
      ImageIcons.hungama,
      ImageIcons.iTap,
      ImageIcons.oneOTT,
      ImageIcons.fancode,
      ImageIcons.distroTv,
      ImageIcons.omTv,
      ImageIcons.hubhopper,
      ImageIcons.aaoNext,
      ImageIcons.kanchanLanka,
      ImageIcons.chanaJor,
      ImageIcons.shortsTv,
      ImageIcons.runtv,
      ImageIcons.eTvWin,
      ImageIcons.wave
    ]
  },
  {
    id: 'plan8',
    name: 'IPTV PLATINUM HD',
    speed: '300 Mbps Unlimited',
    data: 'Unlimited Plan',
    price: '1499',
    durationMonths: '12+2 Months',
    duration: 'Pay For 12 Months & Get 2 Month Free',
    offer: 'Free OTT + Router',
    tag: 'Top Choice',
    showLogos: [ ImageIcons.sonyLiv, ImageIcons.shemaroo, ImageIcons.hungama, ImageIcons.zee5],
    logos: [
      ImageIcons.zee5,
      ImageIcons.sonyLiv,
      ImageIcons.chaupal,
      ImageIcons.travelxp,
      ImageIcons.dangalPlay,
      ImageIcons.shucaeFilms,
      ImageIcons.nammaflix,
      ImageIcons.tarangplus,
      ImageIcons.shemaroo,
      ImageIcons.hungama,
      ImageIcons.iTap,
      ImageIcons.oneOTT,
      ImageIcons.fancode,
      ImageIcons.distroTv,
      ImageIcons.omTv,
      ImageIcons.hubhopper,
      ImageIcons.aaoNext,
      ImageIcons.kanchanLanka,
      ImageIcons.chanaJor,
      ImageIcons.shortsTv,
      ImageIcons.runtv,
      ImageIcons.eTvWin,
      ImageIcons.wave
    ]
  },
  {
    id: 'plan9',
    name: 'IPTV PLATINUM HD',
    speed: '500 Mbps Unlimited',
    data: 'Unlimited Plan',
    price: '1999',
    durationMonths: '12+2 Months',
    duration: 'Pay For 12 Months & Get 2 Month Free',
    offer: 'Free OTT + Router',
    tag: 'Ultra Plan',
    showLogos: [ ImageIcons.sonyLiv, ImageIcons.shemaroo, ImageIcons.hungama, ImageIcons.zee5],
    logos: [
      ImageIcons.zee5,
      ImageIcons.sonyLiv,
      ImageIcons.chaupal,
      ImageIcons.travelxp,
      ImageIcons.dangalPlay,
      ImageIcons.shucaeFilms,
      ImageIcons.nammaflix,
      ImageIcons.tarangplus,
      ImageIcons.shemaroo,
      ImageIcons.hungama,
      ImageIcons.iTap,
      ImageIcons.oneOTT,
      ImageIcons.fancode,
      ImageIcons.distroTv,
      ImageIcons.omTv,
      ImageIcons.hubhopper,
      ImageIcons.aaoNext,
      ImageIcons.kanchanLanka,
      ImageIcons.chanaJor,
      ImageIcons.shortsTv,
      ImageIcons.runtv,
      ImageIcons.eTvWin,
      ImageIcons.wave
    ]
  }
]